import React from "react";
import {TextField} from "@material-ui/core";
import {getLabel} from "../../localization/MainLocalization";
import {not_validate_value} from "../../App";

export const CustomTextField = props => {
    return (
        <TextField
            autoComplete="off"
            helperText={props.helper_text}
            variant="outlined"
            error={props.error}
            name={props.name}
            type={props.type + ""}
            label={<label> {getLabel(props.label)}<span className='text-danger'>{props.required ? "*" : ""}</span></label>}
            value={not_validate_value.includes(props.value)? "": props.value + ""}
            onChange={e => props.onChangeHandle(e.target.name, e.target.value)}
            fullWidth
            disabled={props.viewOnly}
            className={props.disabled ? "disabled-field " + props.className : props.className}
        />
    )
};